import _ from 'lodash';

import {
    FETCH_FOOTER_SECTION
} from '../actions/Types';

export default (state = {}, action) => {
    switch (action.type) {
        case FETCH_FOOTER_SECTION:
            return {...state, ..._.mapKeys(action.payload, 'id')};
        default:
            return state;
    }
}